import React, { useState } from 'react';
import type { AdminResetPasswordSectionProps } from '../../types/admin';

const AdminResetPasswordSection: React.FC<AdminResetPasswordSectionProps> = ({
  onSubmit, 
  onBackToLogin, 
  className = '' 
}) => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(email);
  };

  const handleBackToLogin = () => {
    setEmail('');
    onBackToLogin();
  };

  return (
    <div className={`admin-section admin-reset-password-section ${className}`}>
      <h2 className="admin-section-title">Reset Password</h2>
      
      <form className="admin-section-form" onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Enter your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="admin-section-input"
          required
        />
        
        <button 
          type="submit" 
          className="admin-section-button admin-button-gradient"
        >
          SEND RESET LINK
        </button>
      </form>
      
      <div 
        className="admin-back-link"
        onClick={handleBackToLogin}
      >
        ← Back to Login
      </div>
    </div>
  );
};

export default AdminResetPasswordSection;